import { render } from "./SmallCard.vue?vue&type=template&id=c1a1fdd2"
import script from "./SmallCard.vue?vue&type=script&lang=js"
export * from "./SmallCard.vue?vue&type=script&lang=js"

import exportComponent from "G:\\workspace\\screened-cv-parser\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__